module.exports = __webpack_public_path__ + "img/zhgy_jxk.ade01717.svg";